var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "close",
      attrs: { type: "button", "data-dismiss": "modal", "aria-label": "Close" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [_c("masked-image", { attrs: { src: "/img/icons/clear.svg" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }